// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SeasonalDiscountUnibrow-cls1___29dd5e00d1a01aa6ddc{/*!*/}.SeasonalDiscountUnibrow-cls2___100dc9aa0d5f26669d7{padding-top:15px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SeasonalDiscountUnibrow-cls1___29dd5e00d1a01aa6ddc",
	"cls2": "SeasonalDiscountUnibrow-cls2___100dc9aa0d5f26669d7 SeasonalDiscountUnibrow-cls1___29dd5e00d1a01aa6ddc"
};
export default ___CSS_LOADER_EXPORT___;
